import { createRoot } from 'react-dom/client';
import { assertEnv } from './lib/env';
import { initSentry } from './lib/sentry';
import { reportWebVitals } from './lib/webVitals';
// Importing the i18n module also runs `i18next.init()` once. Doing it
// from main.tsx (before any component renders) means components can
// safely use `useTranslation()` on their first paint without a
// "i18next not initialised yet" warning.
import './i18n';
// Icarus D&D: Newsreader (Serif) fuer Ueberschriften/Markennamen,
// Instrument Sans (Sans) fuer alles andere. Reihenfolge vor `index.css`,
// damit die @font-face Declarations vor dem body-font-stack greifen.
import '@fontsource-variable/newsreader';
import '@fontsource-variable/instrument-sans';
import App from './App.tsx';
import './index.css';

// Fail fast at boot if a required environment variable is missing.
// Doing this *before* anything else gives a clear, actionable error
// instead of an opaque crash inside Supabase or Sentry minutes later.
assertEnv();

// Sentry must be initialised before the first render so the error
// boundary can forward exceptions on the very first paint.
initSentry();

// Web-Vitals -> Sentry Metrics: registriert PerformanceObserver fuer
// CLS / INP / LCP / TTFB / FCP. Muss *nach* `initSentry()` laufen, weil
// der Reporter `Sentry.metrics.*` aufruft – ohne aktiven Client wuerden
// die Metriken stillschweigend verloren gehen.
reportWebVitals();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootEl).render(<App />);
